module.exports = __webpack_public_path__ + "static/media/logo-green.f8df25aa.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/logo-green.svg
// module id = 352
// module chunks = 1